import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f057756&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f057756')) {
      api.createRecord('2f057756', component.options)
    } else {
      api.reload('2f057756', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f057756&", function () {
      api.rerender('2f057756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/guide/index.vue"
export default component.exports